/* ==========================================================================
   NonVictus — comportamiento propio. Sin librerías externas.
   Una función init por componente; cada una sale sola si su elemento no está.
   ========================================================================== */

(function () {
  'use strict';

  var MENOS_MOVIMIENTO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1. Titulares que aparecen palabra a palabra ----------------------- */

  function initPalabras() {
    var nodos = document.querySelectorAll('.mt-palabras:not([data-mt-listo])');
    for (var i = 0; i < nodos.length; i++) {
      var nodo = nodos[i];
      nodo.setAttribute('data-mt-listo', '1');
      if (MENOS_MOVIMIENTO) continue;
      var palabras = (nodo.textContent || '').split(/\s+/).filter(Boolean);
      if (!palabras.length) continue;
      var html = '';
      for (var p = 0; p < palabras.length; p++) {
        var texto = palabras[p].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        html +=
          '<span class="mt-palabra"><span style="--mt-wdelay:' +
          p * 55 +
          'ms">' +
          texto +
          '</span></span>' +
          (p < palabras.length - 1 ? ' ' : '');
      }
      nodo.innerHTML = html;
    }
  }

  /* --- 2. Reveals al hacer scroll (un solo observador compartido) -------- */

  var observadorReveal = null;

  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal:not([data-mt-obs])');
    if (!elementos.length) return;

    if (MENOS_MOVIMIENTO || !('IntersectionObserver' in window)) {
      for (var k = 0; k < elementos.length; k++) {
        elementos[k].classList.add('mt-visible');
        elementos[k].setAttribute('data-mt-obs', '1');
      }
      return;
    }

    if (!observadorReveal) {
      observadorReveal = new IntersectionObserver(
        function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting) {
              entradas[i].target.classList.add('mt-visible');
              observadorReveal.unobserve(entradas[i].target);
            }
          }
        },
        { rootMargin: '0px 0px -11% 0px', threshold: 0.06 }
      );
    }

    for (var j = 0; j < elementos.length; j++) {
      elementos[j].setAttribute('data-mt-obs', '1');
      observadorReveal.observe(elementos[j]);
    }
  }

  /* --- 3. Parallax suave del hero --------------------------------------- */

  function initParallax() {
    var capas = document.querySelectorAll('[data-mt-parallax]');
    if (!capas.length || MENOS_MOVIMIENTO) return;

    var pendiente = false;

    function pintar() {
      pendiente = false;
      for (var i = 0; i < capas.length; i++) {
        var capa = capas[i];
        var caja = capa.getBoundingClientRect();
        if (caja.bottom < -200 || caja.top > window.innerHeight + 200) continue;
        var fuerza = parseFloat(capa.getAttribute('data-mt-parallax')) || 0;
        if (!fuerza) continue;
        var centro = caja.top + caja.height / 2 - window.innerHeight / 2;
        var mover = (centro / window.innerHeight) * fuerza * -1;
        var img = capa.querySelector('img');
        if (img) img.style.transform = 'scale(1.09) translate3d(0,' + mover.toFixed(2) + 'px,0)';
      }
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    pintar();
  }

  /* --- 4. Escena sticky: el visual cambia según el texto que lees -------- */

  function initEscena() {
    var escenas = document.querySelectorAll('[data-mt-escena]');
    if (!escenas.length) return;

    for (var e = 0; e < escenas.length; e++) {
      (function (escena) {
        var pasos = escena.querySelectorAll('.mt-escena__paso');
        var capas = escena.querySelectorAll('.mt-escena__capa');
        var puntos = escena.querySelectorAll('.mt-escena__punto');
        if (!pasos.length || !capas.length) return;

        function activar(indice) {
          for (var i = 0; i < pasos.length; i++) pasos[i].classList.toggle('mt-activa', i === indice);
          for (var c = 0; c < capas.length; c++) capas[c].classList.toggle('mt-activa', c === indice);
          for (var p = 0; p < puntos.length; p++) puntos[p].classList.toggle('mt-activa', p === indice);
        }

        activar(0);

        if (!('IntersectionObserver' in window)) return;

        var obs = new IntersectionObserver(
          function (entradas) {
            for (var i = 0; i < entradas.length; i++) {
              if (entradas[i].isIntersecting) {
                activar(parseInt(entradas[i].target.getAttribute('data-mt-indice'), 10) || 0);
              }
            }
          },
          { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
        );

        for (var s = 0; s < pasos.length; s++) {
          pasos[s].setAttribute('data-mt-indice', s);
          obs.observe(pasos[s]);
        }
      })(escenas[e]);
    }
  }

  /* --- 5. Cifras que cuentan hacia arriba ------------------------------- */

  function initCifras() {
    var cifras = document.querySelectorAll('[data-mt-cifra]:not([data-mt-obs])');
    if (!cifras.length) return;

    function contar(el) {
      var destino = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      var decimales = (el.getAttribute('data-mt-cifra').split('.')[1] || '').length;
      if (MENOS_MOVIMIENTO) {
        el.textContent = destino.toFixed(decimales);
        return;
      }
      var inicio = null;
      var duracion = 1500;
      function paso(t) {
        if (inicio === null) inicio = t;
        var avance = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - avance, 3);
        el.textContent = (destino * suave).toFixed(decimales);
        if (avance < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      for (var n = 0; n < cifras.length; n++) contar(cifras[n]);
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].isIntersecting) {
            contar(entradas[i].target);
            obs.unobserve(entradas[i].target);
          }
        }
      },
      { threshold: 0.4 }
    );

    for (var j = 0; j < cifras.length; j++) {
      cifras[j].setAttribute('data-mt-obs', '1');
      cifras[j].textContent = '0';
      obs.observe(cifras[j]);
    }
  }

  /* --- 6. Preguntas frecuentes (acordeón con altura animada) ------------- */

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item:not([data-mt-listo])');
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        item.setAttribute('data-mt-listo', '1');
        var boton = item.querySelector('.mt-faq__boton');
        var panel = item.querySelector('.mt-faq__panel');
        if (!boton || !panel) return;

        boton.setAttribute('aria-expanded', 'false');

        boton.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-abierto');
          var hermanos = item.parentNode.querySelectorAll('.mt-faq__item.mt-abierto');
          for (var h = 0; h < hermanos.length; h++) {
            if (hermanos[h] === item) continue;
            hermanos[h].classList.remove('mt-abierto');
            hermanos[h].querySelector('.mt-faq__panel').style.height = '0px';
            hermanos[h].querySelector('.mt-faq__boton').setAttribute('aria-expanded', 'false');
          }
          if (abierto) {
            panel.style.height = panel.scrollHeight + 'px';
            void panel.offsetHeight;
            panel.style.height = '0px';
            item.classList.remove('mt-abierto');
            boton.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('mt-abierto');
            boton.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
            window.setTimeout(function () {
              if (item.classList.contains('mt-abierto')) panel.style.height = 'auto';
            }, 560);
          }
        });
      })(items[i]);
    }
  }

  /* --- 7. Galería de la página de producto ------------------------------ */

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]:not([data-mt-listo])');
    for (var g = 0; g < galerias.length; g++) {
      (function (galeria) {
        galeria.setAttribute('data-mt-listo', '1');
        var minis = galeria.querySelectorAll('.mt-mini');
        var grandes = galeria.querySelectorAll('.mt-producto__principal img');
        if (!minis.length || !grandes.length) return;

        function mostrar(indice) {
          for (var i = 0; i < grandes.length; i++) grandes[i].classList.toggle('mt-activa', i === indice);
          for (var m = 0; m < minis.length; m++) minis[m].classList.toggle('mt-activa', m === indice);
        }

        for (var k = 0; k < minis.length; k++) {
          (function (indice) {
            minis[indice].addEventListener('click', function () {
              mostrar(indice);
            });
          })(k);
        }

        mostrar(0);
      })(galerias[g]);
    }
  }

  /* --- 8. Selector de cantidad ------------------------------------------ */

  function initCantidad() {
    var cajas = document.querySelectorAll('.mt-cantidad__caja:not([data-mt-listo])');
    for (var i = 0; i < cajas.length; i++) {
      (function (caja) {
        caja.setAttribute('data-mt-listo', '1');
        var campo = caja.querySelector('.mt-cantidad__input');
        var botones = caja.querySelectorAll('[data-mt-cantidad]');
        if (!campo) return;
        for (var b = 0; b < botones.length; b++) {
          (function (boton) {
            boton.addEventListener('click', function () {
              var valor = parseInt(campo.value, 10) || 1;
              valor += boton.getAttribute('data-mt-cantidad') === 'mas' ? 1 : -1;
              campo.value = Math.max(1, valor);
              campo.dispatchEvent(new Event('change', { bubbles: true }));
            });
          })(botones[b]);
        }
      })(cajas[i]);
    }
  }

  /* --- 9. Cuenta atrás hasta una fecha REAL ------------------------------ */

  function initContador() {
    var nodos = document.querySelectorAll('[data-mt-fin]:not([data-mt-listo])');
    for (var i = 0; i < nodos.length; i++) {
      (function (nodo) {
        nodo.setAttribute('data-mt-listo', '1');
        var fin = Date.parse(nodo.getAttribute('data-mt-fin'));
        if (isNaN(fin)) return;

        var campos = {
          dias: nodo.querySelector('[data-mt-u="dias"]'),
          horas: nodo.querySelector('[data-mt-u="horas"]'),
          min: nodo.querySelector('[data-mt-u="min"]'),
          seg: nodo.querySelector('[data-mt-u="seg"]'),
        };
        var titulo = nodo.querySelector('[data-mt-titulo]');
        var textoFin = nodo.getAttribute('data-mt-texto-fin') || '';

        function dos(n) { return n < 10 ? '0' + n : '' + n; }

        function pintar() {
          var resta = fin - Date.now();
          if (resta <= 0) {
            nodo.classList.add('mt-contador--fin');
            if (titulo && textoFin) titulo.textContent = textoFin;
            window.clearInterval(reloj);
            return;
          }
          var seg = Math.floor(resta / 1000);
          var d = Math.floor(seg / 86400);
          var h = Math.floor((seg % 86400) / 3600);
          var m = Math.floor((seg % 3600) / 60);
          var s = seg % 60;
          if (campos.dias) campos.dias.textContent = dos(d);
          if (campos.horas) campos.horas.textContent = dos(h);
          if (campos.min) campos.min.textContent = dos(m);
          if (campos.seg) campos.seg.textContent = dos(s);
        }

        pintar();
        var reloj = window.setInterval(pintar, 1000);
      })(nodos[i]);
    }
  }

  /* --- 10. Barra de compra fija en móvil -------------------------------- */

  function initBarra() {
    var barra = document.querySelector('.mt-barra:not([data-mt-listo])');
    if (!barra) return;
    barra.setAttribute('data-mt-listo', '1');

    var referencia = document.querySelector('.mt-producto__form');
    if (!referencia || !('IntersectionObserver' in window)) {
      barra.classList.add('mt-visible');
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        // La barra aparece cuando el bloque de compra deja de verse
        barra.classList.toggle('mt-visible', !entradas[0].isIntersecting);
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
    obs.observe(referencia);

    var boton = barra.querySelector('[data-mt-ir-a-compra]');
    if (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        referencia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* --- 10b. Comprar ahora (añade y va directo a pagar) ------------------- */

  function initComprarYa() {
    var botones = document.querySelectorAll('[data-mt-comprar-ya]:not([data-mt-listo])');
    for (var i = 0; i < botones.length; i++) {
      (function (boton) {
        boton.setAttribute('data-mt-listo', '1');
        boton.addEventListener('click', function () {
          var formulario = boton.closest('form');
          if (!formulario) return;

          var id = formulario.querySelector('input[name="id"]');
          if (!id || !id.value) return;

          var campoCantidad = formulario.querySelector('input[name="quantity"]');
          var cantidad = campoCantidad ? parseInt(campoCantidad.value, 10) || 1 : 1;

          var textoOriginal = boton.textContent;
          boton.textContent = boton.getAttribute('data-mt-cargando') || textoOriginal;
          boton.setAttribute('disabled', 'disabled');

          fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id.value, quantity: cantidad }] }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error('no se pudo añadir');
              window.location.href = '/checkout';
            })
            .catch(function () {
              // Si algo falla, no dejamos al cliente colgado: se envía el
              // formulario normal, que lleva al carrito.
              boton.textContent = textoOriginal;
              boton.removeAttribute('disabled');
              formulario.submit();
            });
        });
      })(botones[i]);
    }
  }

  /* --- 11b. Comparador antes / después ---------------------------------- */

  function initComparador() {
    var marcos = document.querySelectorAll('.mt-comparador__marco:not([data-mt-listo])');
    for (var i = 0; i < marcos.length; i++) {
      (function (marco) {
        marco.setAttribute('data-mt-listo', '1');
        var tirador = marco.querySelector('.mt-comparador__tirador');
        var etiquetaAntes = marco.querySelector('.mt-comparador__etiqueta--antes');
        var etiquetaDespues = marco.querySelector('.mt-comparador__etiqueta--despues');
        if (!tirador) return;

        var arrastrando = false;

        function colocar(porcentaje) {
          var p = Math.min(100, Math.max(0, porcentaje));
          marco.style.setProperty('--mt-pos', p + '%');
          tirador.setAttribute('aria-valuenow', Math.round(p));
          // Las etiquetas se apartan cuando el tirador se les echa encima
          if (etiquetaAntes) etiquetaAntes.style.opacity = p < 22 ? '0' : '1';
          if (etiquetaDespues) etiquetaDespues.style.opacity = p > 78 ? '0' : '1';
        }

        function desdeEvento(e) {
          var caja = marco.getBoundingClientRect();
          var x = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX) - caja.left;
          colocar((x / caja.width) * 100);
        }

        function empezar(e) {
          arrastrando = true;
          marco.setAttribute('data-mt-arrastrando', '1');
          desdeEvento(e);
        }
        function mover(e) {
          if (!arrastrando) return;
          if (e.cancelable) e.preventDefault();
          desdeEvento(e);
        }
        function soltar() {
          arrastrando = false;
          marco.removeAttribute('data-mt-arrastrando');
        }

        marco.addEventListener('mousedown', empezar);
        window.addEventListener('mousemove', mover);
        window.addEventListener('mouseup', soltar);

        marco.addEventListener('touchstart', empezar, { passive: true });
        window.addEventListener('touchmove', mover, { passive: false });
        window.addEventListener('touchend', soltar);

        // Al pasar el ratón sin arrastrar también sigue el cursor: se descubre solo
        if (marco.getAttribute('data-mt-seguir') === 'true') {
          marco.addEventListener('mousemove', function (e) {
            if (!arrastrando) desdeEvento(e);
          });
        }

        // Teclado: flechas izquierda/derecha
        tirador.addEventListener('keydown', function (e) {
          var actual = parseFloat(tirador.getAttribute('aria-valuenow')) || 50;
          if (e.key === 'ArrowLeft') { colocar(actual - 4); e.preventDefault(); }
          if (e.key === 'ArrowRight') { colocar(actual + 4); e.preventDefault(); }
          if (e.key === 'Home') { colocar(0); e.preventDefault(); }
          if (e.key === 'End') { colocar(100); e.preventDefault(); }
        });

        var inicial = parseFloat(marco.getAttribute('data-mt-inicio'));
        colocar(isNaN(inicial) ? 50 : inicial);

        // Guiño de entrada: el tirador se mueve solo la primera vez que se ve,
        // para que se entienda que es arrastrable.
        if (!MENOS_MOVIMIENTO && 'IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (entradas) {
            if (!entradas[0].isIntersecting) return;
            obs.disconnect();
            var partida = isNaN(inicial) ? 50 : inicial;
            var pasos = [partida + 16, partida - 14, partida];
            pasos.forEach(function (destino, idx) {
              window.setTimeout(function () {
                if (arrastrando) return;
                marco.style.transition = 'none';
                var desde = parseFloat(tirador.getAttribute('aria-valuenow')) || partida;
                var t0 = null;
                function anima(t) {
                  if (t0 === null) t0 = t;
                  var k = Math.min((t - t0) / 620, 1);
                  var suave = 1 - Math.pow(1 - k, 3);
                  colocar(desde + (destino - desde) * suave);
                  if (k < 1 && !arrastrando) window.requestAnimationFrame(anima);
                }
                window.requestAnimationFrame(anima);
              }, 500 + idx * 680);
            });
          }, { threshold: 0.4 });
          obs.observe(marco);
        }
      })(marcos[i]);
    }
  }

  /* --- 11. Ruleta ------------------------------------------------------- */

  function initRuleta() {
    var ruleta = document.querySelector('.mt-ruleta:not([data-mt-listo])');
    if (!ruleta) return;
    ruleta.setAttribute('data-mt-listo', '1');

    var llave = 'mt-ruleta-' + (ruleta.getAttribute('data-mt-llave') || 'v1');
    var editor = document.documentElement.classList.contains('shopify-design-mode') ||
      (window.Shopify && window.Shopify.designMode);

    // Un solo intento por navegador. En el editor siempre se muestra.
    var yaJugado = null;
    try { yaJugado = window.localStorage.getItem(llave); } catch (e) { yaJugado = null; }
    if (yaJugado && !editor) return;

    var disco = ruleta.querySelector('.mt-ruleta__disco');
    var boton = ruleta.querySelector('.mt-ruleta__girar');
    var intro = ruleta.querySelector('.mt-ruleta__intro');
    var gana = ruleta.querySelector('[data-mt-gana]');
    var pierde = ruleta.querySelector('[data-mt-pierde]');
    var cerrar = ruleta.querySelectorAll('[data-mt-cerrar]');
    var copiar = ruleta.querySelector('[data-mt-copiar]');
    var sectores = ruleta.querySelectorAll('.mt-ruleta__sector').length || 8;
    var espera = parseInt(ruleta.getAttribute('data-mt-espera'), 10);
    if (isNaN(espera)) espera = 6;

    function abrir() {
      ruleta.classList.add('mt-montada');
      // Doble red: rAF para que el desvanecido salga fino, y un temporizador
      // de respaldo porque rAF no dispara si la pestaña está en segundo plano.
      window.requestAnimationFrame(function () { ruleta.classList.add('mt-visible'); });
      window.setTimeout(function () { ruleta.classList.add('mt-visible'); }, 60);
      document.body.style.overflow = 'hidden';
    }

    function cerrarTodo() {
      ruleta.classList.remove('mt-visible');
      document.body.style.overflow = '';
      window.setTimeout(function () { ruleta.classList.remove('mt-montada'); }, 460);
    }

    for (var c = 0; c < cerrar.length; c++) {
      cerrar[c].addEventListener('click', cerrarTodo);
    }
    ruleta.addEventListener('click', function (e) { if (e.target === ruleta) cerrarTodo(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ruleta.classList.contains('mt-visible')) cerrarTodo();
    });

    // Sorteo con el generador criptográfico del navegador. La probabilidad de
    // premio se configura desde el editor (data-mt-prob, en tanto por ciento).
    var probabilidad = parseFloat(ruleta.getAttribute('data-mt-prob'));
    if (isNaN(probabilidad)) probabilidad = 50;
    probabilidad = Math.min(100, Math.max(0, probabilidad));

    function suerteReal() {
      var azar;
      if (window.crypto && window.crypto.getRandomValues) {
        var b = new Uint32Array(1);
        window.crypto.getRandomValues(b);
        azar = b[0] / 4294967296;
      } else {
        azar = Math.random();
      }
      return azar * 100 < probabilidad;
    }

    var girando = false;

    if (boton) {
      boton.addEventListener('click', function () {
        if (girando) return;
        girando = true;
        boton.setAttribute('disabled', 'disabled');

        var premiado = suerteReal();
        try { window.localStorage.setItem(llave, premiado ? 'gana' : 'pierde'); } catch (e) {}

        // Los sectores pares premian, los impares no. Se elige uno al azar
        // del tipo que ha salido y se para justo ahí: la animación refleja
        // el resultado, no lo decide.
        var mitad = sectores / 2;
        var cual = Math.floor(Math.random() * mitad) * 2 + (premiado ? 0 : 1);
        var grados = 360 / sectores;
        var destino = 360 * 5 + (360 - (cual * grados + grados / 2));

        if (disco) disco.style.transform = 'rotate(' + destino + 'deg)';

        window.setTimeout(function () {
          if (intro) intro.style.display = 'none';
          var panel = premiado ? gana : pierde;
          if (panel) panel.classList.add('mt-visible');
        }, 4800);
      });
    }

    if (copiar) {
      copiar.addEventListener('click', function () {
        var codigo = copiar.getAttribute('data-mt-copiar') || '';
        var original = copiar.textContent;
        function hecho() {
          copiar.textContent = copiar.getAttribute('data-mt-hecho') || 'Copiado';
          window.setTimeout(function () { copiar.textContent = original; }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(hecho, hecho);
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = codigo;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(tmp);
          hecho();
        }
      });
    }

    if (editor) abrir();
    else window.setTimeout(abrir, espera * 1000);
  }

  /* --- Arranque --------------------------------------------------------- */

  function arrancar() {
    initPalabras();
    initReveal();
    initParallax();
    initEscena();
    initCifras();
    initFaq();
    initGaleria();
    initCantidad();
    initContador();
    initBarra();
    initComprarYa();
    initComparador();
    initRuleta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de Shopify recarga secciones sueltas: hay que re-inicializar. */
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:section:select', arrancar);
})();
